/** Ширина плаваючого меню групи (320px) + відступ від правого краю вікна: меню не виходить за екран (прототип v4: min(left, W − 340)). */
const MENU_SPACE = 340;

/** Координати плаваючого меню під кнопкою: лівий край кнопки (або ближче до лівого краю вікна) і 6px під нею. */
export function menuAnchor(button: HTMLElement): { x: number; y: number } {
  const r = button.getBoundingClientRect();
  return { x: Math.round(Math.max(8, Math.min(r.left, window.innerWidth - MENU_SPACE))), y: Math.round(r.bottom + 6) };
}
